module.exports = __webpack_public_path__ + "assets/connected.97240307.svg";